import React from 'react';

export default function Dashboard() {
  return (
    <div className="page">
      <header className="header">
        <h1>Dashboard</h1>
      </header>

      {/* Hero banner */}
      <section className="dash-hero">
        <div className="dash-hero-title">AI-Powered Solutions for Industry</div>
        <p className="dash-hero-sub">Maskan builds conversational AI, automation, and integrations that streamline operations and accelerate growth.</p>
        {/* <button className="btn-cta">Generate Report</button> */}
      </section>

      {/* KPI cards */}
      <section className="stat-grid">
        <div className="stat-card">
          <div className="stat-label">Active Projects</div>
          <div className="stat-value">8</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">AI Agents</div>
          <div className="stat-value">5</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Integrations</div>
          <div className="stat-value">12</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Deployments</div>
          <div className="stat-value">21</div>
        </div>
      </section>

      {/* Compliance/progress style bar */}
      <section className="progress-card">
        <div className="progress-title">Overall Success Rate</div>
        <div className="progress-bar"><span style={{ width: '74%' }} /></div>
        <div className="progress-meta">74% on track · last 30 days</div>
      </section>

      {/* Two-up charts */}
      <section className="charts-grid">
        <div className="chart-card">
          <div className="chart-title">Channel Distribution</div>
          <div className="chart-placeholder">Pie / Donut Chart</div>
        </div>
        <div className="chart-card">
          <div className="chart-title">Conversation Trends (6 months)</div>
          <div className="chart-placeholder">Line Chart</div>
        </div>
      </section>

      {/* Actions */}
      <section className="actions-grid">
        <div className="action-card">
          <div className="action-title">Priority Actions</div>
          <div className="action-item">
            <div>
              <strong>Setup WhatsApp webhook</strong>
              <div className="muted">Connect production number</div>
            </div>
            <button className="pill danger">Review</button>
          </div>
          <div className="action-item">
            <div>
              <strong>Agent prompt audit</strong>
              <div className="muted">Refresh sales script</div>
            </div>
            <button className="pill warn">Schedule</button>
          </div>
        </div>

        <div className="action-card">
          <div className="action-title">Quick Actions</div>
          <div className="quick-grid">
            <button className="quick">Create Agent</button>
            <button className="quick">Register Number</button>
            <button className="quick">Add Integration</button>
            <button className="quick">View Reports</button>
          </div>
        </div>
      </section>
    </div>
  );
}
